import {
    IKhoLeadAssignRequest,
    IKhoLeadFilter,
    IKhoLeadInteractionRequest,
    IKhoLeadRoundRobinSaveRequest,
    IKhoLeadUpdateRequest,
} from "../models/response/crm-survey/IKhoLead";
import { apiClient } from "./apiClient";

export const KHO_LEAD_API_END_POINT = "kho-lead";

const buildQuery = (params: Record<string, any>) => {
    const search = new URLSearchParams();
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
            search.append(key, String(value));
        }
    });
    const qs = search.toString();
    return qs ? `?${qs}` : "";
};

export const khoLeadApi = {
    /** Danh sách Lead theo bộ lọc */
    select: (filter: IKhoLeadFilter) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}${buildQuery({ ...filter })}`),

    /** Thống kê số Lead theo từng trạng thái */
    selectThongKe: (dm_coso_id: number) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/thong-ke${buildQuery({ dm_coso_id })}`),

    detail: (id: number) => apiClient.get(`${KHO_LEAD_API_END_POINT}/${id}`),

    /** Hồ sơ phụ huynh trùng số điện thoại trong cơ sở của lead (chỉ đọc) */
    selectPhCandidates: (id: number, params: { ho_ten: string; phone: string; email: string }) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/${id}/ph-candidates${buildQuery({ ...params })}`),

    /** Cập nhật thông tin + trạng thái Lead */
    update: (id: number, payload: IKhoLeadUpdateRequest) =>
        apiClient.put(`${KHO_LEAD_API_END_POINT}/${id}`, payload),

    /** Giao / chuyển Lead thủ công */
    assign: (payload: IKhoLeadAssignRequest) =>
        apiClient.put(`${KHO_LEAD_API_END_POINT}/assign`, payload),

    /** Phân bổ tự động round-robin cho 1 Lead */
    autoAssign: (id: number) =>
        apiClient.put(`${KHO_LEAD_API_END_POINT}/${id}/auto-assign`, {}),

    /** Lead bù dự kiến (chỉ xem trước, không thay đổi dữ liệu) */
    selectCompensationPreview: (id: number) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/${id}/lead-bu`),

    /** Xác nhận Unqualified, hệ thống tự xếp Lead bù */
    markUnqualified: (id: number, payload: { reason: string; note?: string }) =>
        apiClient.put(`${KHO_LEAD_API_END_POINT}/${id}/unqualified`, payload),

    selectInteractions: (id: number) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/${id}/tuong-tac`),

    addInteraction: (id: number, payload: IKhoLeadInteractionRequest) =>
        apiClient.post(`${KHO_LEAD_API_END_POINT}/${id}/tuong-tac`, payload),

    selectHistory: (id: number) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/${id}/lich-su`),

    delete: (id: number) => apiClient.delete(`${KHO_LEAD_API_END_POINT}/${id}`),

    /** Cấu hình round-robin của cơ sở */
    selectRoundRobin: (dm_coso_id: number) =>
        apiClient.get(`${KHO_LEAD_API_END_POINT}/round-robin${buildQuery({ dm_coso_id })}`),

    saveRoundRobin: (payload: IKhoLeadRoundRobinSaveRequest) =>
        apiClient.put(`${KHO_LEAD_API_END_POINT}/round-robin`, payload),
};
